<template>
  <div>
    <div class="card bet-board-card animate-slide-y">
      <div class="card-text">
        <div>
          <div class="mb-4 flex items-center gap-1 font-medium">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            ><path
              fill-rule="evenodd"
              d="M3 10a.75.75 0 01.75-.75h10.5a.75.75 0 010 1.5H3.75A.75.75 0 013 10z"
              clip-rule="evenodd"
            ></path>
            </svg> เลือกประเภทการแทง 
          </div>
          <div class="grid grid-cols-2 gap-2 pb-4 sm:grid-cols-3 lg:grid-cols-5">
            <div 
              v-for="(winTab, index) in winTabs" 
              :key="index"
              class="v-popper v-popper--theme-tooltip"
            >
              <button
                class="bet-type-choice-btn w-full px-2"
                :class="{'active': selectType.includes(winTab.number_type.id)}"
                type="button"
                @click="changeStatus(winTab.number_type.id, winTab.number_type.name)"
              >
                <div class="flex items-center justify-center">
                  <div class="flex w-full items-center justify-center font-bold">
                    {{ winTab.number_type.name }}
                    <span class="pay-rate-chip chip ml-2 rounded-full text-xs font-semibold">{{ winTab.userReward | number_comma }}</span>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div class="mb-2 flex min-h-[46px] items-center justify-between gap-2">
          <div class="flex items-center gap-1 font-medium">
            <svg
              data-v-aee14c88=""
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            ><path
              fill-rule="evenodd"
              d="M3 10a.75.75 0 01.75-.75h10.5a.75.75 0 010 1.5H3.75A.75.75 0 013 10z"
              clip-rule="evenodd"
            ></path></svg> กรอกเลขวิน
          </div>
        </div>
        <div class="mx-auto md:w-1/4">
          <label
            maxlength="6"
            inputmode="numeric"
            class="text-right"
            placeholder="กรอกเลขวิน"
          ><div class="font-medium"></div><div class="input-group relative">
            <input
              v-model="winNumber"
              maxlength="6"
              inputmode="numeric"
              class="text-right w-full"
              placeholder="กรอกเลขวิน"
              type="text"
              @input="filterNumberInput"
            ></div>
          </label>
        </div>
        <div class="flex items-center justify-center gap-2 py-4"></div>
        <div 
          v-if="winNumber.length >= 3"
          class="preview-win-number card"
        >
          <div class="card-title flex flex-row pb-0">
            <p>ตัวอย่างเลข</p>
            
            <button
              class="submit-win-picker-btn ml-auto"
              type="button"
              @click="selectAll"
            >
              <div class="flex items-center justify-center">
                <svg
                  data-v-aee14c88=""
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                ><path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"></path></svg> เพิ่มเข้ารายการแทง
              </div>
            </button>
          </div><div class="card-actions space-y-3">
            <div
              v-for="(winTab, index) in winTabs" 
              :key="index"
              class="mt-3"
            >
              <template v-if="selectType.length == 0 || selectType.includes(winTab.number_type.id)">
                <div>
                  <div class="flex flex-col items-start gap-3">
                    <div class="preview-type px-4 py-2">
                      {{ winTab.number_type.name }} ({{ selectAmountList(winTab, index).length }})
                    </div>
                  </div><div class="grid grid-cols-5 gap-2 py-2 sm:grid-cols-10">
                    <div
                      v-for="(item,i) in selectAmountList(winTab, index)"
                      :key="i"
                    >
                      <button
                        class="preview-no w-full px-1 py-1 text-center"
                        :class="{
                          'brightness-50': unSelectAmount.includes(item.valueUnique),
                          'color-warning': item.status == ALMOST
                        }"
                        type="button"
                        :disabled="checkDisable(item)"
                        @click="onClickAmount(item)"
                      >
                        <div class="flex items-center justify-center">
                          {{ checkDisable(item) ? $t('button.out-of-stock') : item.number }}
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { findPermutations } from '@/plugins/helper'

export default {
  components:{
  },
  props : {
    switchToggle : {
      type:Boolean,
      default:false
    },
    indexSelect : { 
      type:Number,
      default:0
    },
    userSelect:{
      type:Array,
      default:()=>{
        return[]
      }
    },
    filterNumber:{
      type:String,
      default:()=>''
    },     
    voucher:{
      type:Object,
      default:()=>{}
    },
    winTabs: {
      type: Array,
      default: () => {
        return []
      }
    }
  },   
  data (){
    return { 
      selectAmount: [],
      selectType: [], 
      toggleSelected: 0,
      selectAmountBase: [],
      LIMITL : 2, 
      ALMOST : 1, 
      NORMAL : 0,
      winNumber: '',
      unSelectAmount: [],
    }
  },
  
  computed : {
    selectWinTabs () { 
      return this.winTabs.filter((_, index) => this.selectType.includes(index));
    }
  },
  
  watch:{   
    indexSelect () { 
      this.checkStatusActive()
    },
    toggleSelected () { 
      this.checkStatusActive()
    },

    userSelect () {
      this.checkStatusActive()
    },

    winNumber () {
      this.unSelectAmount = []
    },
  }, 
  async created () { 
    this.checkStatusActive()
    this.selectType.push(this.winTabs[0].number_type.id)
  },
  methods: {
    selectAll () {

      for (let i = 0; i < this.winTabs.length; i++) {
        if (!this.selectType.includes(this.winTabs[i].number_type.id)) {
          continue
        }

        let listAmounts = this.selectAmountList(this.winTabs[i], i);

        listAmounts.forEach(item => {

          if (this.selectAmount.includes(item.valueUnique)) {
            return;
          }

          if (this.unSelectAmount.includes(item.valueUnique)) {
            return;
          }

          this.addValue(item)
        }); 
      }

      this.winNumber = ''
    },

    getPermutations (str, length) {
      if (length === 1) return str.split('');

      const perms = new Set();
      for (let i = 0; i < str.length; i++) {
        const char = str[i];
        const remainingChars = str.slice(0, i) + str.slice(i + 1);
        const remainingPerms = this.getPermutations(remainingChars, length - 1);
        for (const perm of remainingPerms) {
          perms.add(char + perm);
        }
      }
      return Array.from(perms);
    },

    selectAmountList (tab, index) {

      return this.getPermutations(this.winNumber, tab.number_type.digit).map(x => {

        let result = {
          value : x,
          valueUnique: `${x}:${tab.number_type.id}`,
          number : this.changeNumbertoString(x),
          status : this.NORMAL,
          userReward : 0,
          index: index
        } 

        let limitFind = (tab.limit_conditions || []).filter(x => x.number === result.number) 
        
        if(limitFind && limitFind.length !==0){   
          let reward = Math.min.apply(Math,limitFind.map(x=>x.quota_reward))  
          result.status = reward===0 ? this.LIMITL : this.ALMOST
          result.userReward =  reward
        }

        return result
      })
    },

    checkLimitCondition (item) { 
      let check = item.status ? item.status : null
      switch(check){
        case this.NORMAL:
          return ''
        case this.ALMOST:
          return 'red'
        case this.LIMITL:
          return 'red'
          
      }
      return '' 
    }, 

    changeStatus (id, name) { 
      this.$ga.event('Button', 'ToggleSelectType', 'ThreeDigitPage', name)
      this.$emit('changeStatus',id)
      this.checkStatusActive ()

      const index = this.selectType.indexOf(id);

      if (index !== -1 && this.selectType.length == 1) {
        return
      }
      
      if (index !== -1) {
        this.selectType.splice(index, 1);
      } else {
        this.selectType.push(id);
      }
    }, 
    
    checkDisable (item) {
      let check = item.status ? item.status : null

      return check === this.LIMITL ? true : false
    }, 

    checkStatusActive () {
      this.resetBoardDisplay()

      this.userSelect.forEach(element => {
        this.selectAmount.push(`${element.number}:${element.number_type_id}`) 
      }); 
    },

    resetBoardDisplay () {  
      this.selectAmount = []  
    },

    changeNumbertoString (value){   
      return value.toString()  
    },

    switchNumbertoString (value) {
      return findPermutations(this.changeNumbertoString(value))
      .filter(x=>!this.selectAmount.includes(parseInt(x)))
      .map(x=>this.selectAmountBase.find(y=>y.number===x)) 
    },

    async addValue (item) {
      let changeNumbertoString = item.number

      this.$ga.event('Button', 'Add&DeleteValue', 'WinDigitPage', changeNumbertoString)

      let arrayResult = this.switchToggle && !this.selectAmount.includes(item.valueUnique) 
      ? this.switchNumbertoString (item.value)
      : [item]

      this.loopAdd(arrayResult)
    },  

    loopAdd (array) { 
      let Bypass = false 
      let stakeMaxNumber = (this.voucher.rules || {}).stake_max_number
      let checkVoucherStake = this.voucher.rules && stakeMaxNumber

      array.forEach(e=>{
        let status = this.selectAmount.includes(e.valueUnique)
        let actionStatus = status ? 'delValue': 'addValue' 
  
        if( checkVoucherStake &&
            this.userSelect.length >= parseInt(stakeMaxNumber) &&
            actionStatus === 'addValue'
        ) { 
          if(!Bypass) {  
            this.$nextTick(()=>{
              this.checkStatusActive() 
            }) 
          }
          
          Bypass = true
          return
        } 

        if (e.status !== this.LIMITL){ 
          let price = e.status === this.NORMAL ? this.winTabs[e.index].userReward : e.userReward
          this.$emit(actionStatus,price,e.number,this.winTabs[e.index].number_type.id, null, null, null)
        }
      }) 
    },

    onClickAmount (item) {
      const index = this.unSelectAmount.indexOf(item.valueUnique);

      if (index !== -1) {
        this.unSelectAmount.splice(index, 1);
      } else {
        this.unSelectAmount.push(item.valueUnique);
      }
    },

    filterNumberInput (event) {
      this.winNumber = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    }
  }
}
</script> 
<style scoped>
@media only screen and (min-width: 1264) {
  .column-five {
    flex: 0 0 10% !important;
    max-width: 10% !important;
  }
}

.win-number {
  max-width: 320px;
}

.bet-board-card {
  --tw-text-opacity: 1;
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
  color: rgb(0 0 0 / var(--tw-text-opacity));
  --tw-gradient-from: #fd9f59 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(253, 159, 89, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #f5781d var(--tw-gradient-to-position);
}

.card {
  background: radial-gradient(ellipse at center top,  var(--bg-secondary-color-v2), var(--bg-secondary-color-v2), var(--bg-secondary-color-v2));
  border-style: none;
  border-radius: .5em;
}

.bet-board-card .card-text, .bet-board-card .card-title {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.bet-board-card .bet-type-choice-btn, .bet-board-card .two-digit-feature-btn {
  --tw-text-opacity: 1;
  background: radial-gradient(ellipse at center top, #383838, #171717);
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

svg {
  height: 1.25rem;
  width: 1.25rem;
}

.btn, [type=button], [type=submit], button {
  align-items: center;
  border-radius: .375rem;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  justify-content: center;
  line-height: 1.5rem;
  padding: .5rem .75rem;
  position: relative;
  touch-action: manipulation;
  transition: all .3s cubic-bezier(.4,0,.2,1);
}

.bet-board-card .bet-type-choice-btn.active, .bet-board-card .two-digit-feature-btn.active {
  border-width: 1px;
  --tw-border-opacity: 1;
  background: radial-gradient(ellipse at center top, #fff, #fff);
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.bet-board-card .bet-type-choice-btn.active .pay-rate-chip, .bet-board-card .two-digit-feature-btn.active .pay-rate-chip {
  --tw-text-opacity: 1;
  background: radial-gradient(ellipse at center top, #383838, #171717);
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.card .card-text {
  padding: .75rem;
}

.card .card-actions {
    padding: .75rem;
}

.input-group {
  align-items: center;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: .25rem;
  color: #374151;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  transition: all .2s cubic-bezier(.4,0,.2,1);
}

input {
  padding: .5rem .75rem;
  outline:none;
}

.preview-win-number {
  background-image: linear-gradient(to bottom, var(--bg-primary-300));
  background-color: var(--bg-primary-300);
}

.card .card-title {
  align-items: center;
  color: #1f2937;
  display: flex;
  font-size: 1.125rem;
  font-weight: 600;
  justify-content: space-between;
  padding: .75rem;
}

.preview-type {
  border-radius: .5rem;
  --tw-bg-opacity: 1;
  background-color: var(--bg-secondary-color-v2);
}

.btn, [type=button], [type=submit], button {
  align-items: center;
  background-color: var(--bg-secondary-color-v2);
  border-radius: .375rem;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  justify-content: center;
  line-height: 1.5rem;
  padding: .5rem .75rem;
  position: relative;
  touch-action: manipulation;
  transition: all .3s cubic-bezier(.4,0,.2,1);
}

.btn:hover, [type=button]:hover, [type=submit]:hover, button:hover {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
  filter: brightness(.9);
}

.bet-board-card .bet-type-choice-btn .pay-rate-chip, .bet-board-card .two-digit-feature-btn .pay-rate-chip {
  --tw-bg-opacity: 1;
  background-color: rgba(251, 239, 231);
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.btn .disabled, .btn:disabled, [type=button] .disabled, [type=button]:disabled, [type=submit] .disabled, [type=submit]:disabled, button .disabled, button:disabled {
  cursor: not-allowed !important;
  opacity: .5;
  pointer-events: none;
}

.color-warning {
  background-color: #FF7F50;
}

</style>